"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.natalie.description': 'Friendly, intelligent American perfect for narration.',
};
